import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Settings2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export const AlertSettingsDialog = ({ threshold, onSaved }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(threshold);
  useEffect(() => { if (open) setValue(threshold); }, [open, threshold]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/settings", { alert_threshold: Number(value) });
      toast.success(t("success"));
      onSaved(data);
      setOpen(false);
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button variant="outline" data-testid="alert-settings-btn"><Settings2 className="w-4 h-4" />{t("alertSettings")}</Button></DialogTrigger>
      <DialogContent data-testid="alert-settings-dialog">
        <DialogHeader><DialogTitle>{t("alertSettings")}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label>{t("alertThreshold")}</Label>
            <Input type="number" min={1} max={100} data-testid="alert-threshold-input" value={value} onChange={(e) => setValue(e.target.value)} required />
            <p className="text-xs text-slate-500">{t("alertThresholdHint")}</p>
          </div>
          <DialogFooter><Button type="submit" data-testid="alert-settings-save">{t("save")}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
